export const CLIENT_PROJECTS_DIALOG_TABLE_KEY = 'CLIENT_PROJECTS_DIALOG';
